import { Store } from '@ngrx/store';
import { Session } from 'src/models/session';
import * as fromSession from 'src/app/app-store/reducers';

export const getLoginSession = (store: Store) => store.select<Session>(fromSession.getSession as any);
